export default "__VITE_ASSET__CzZU8bvV__"